/* eslint-disable */
import { makeAutoObservable, runInAction } from 'mobx';
import { CatWeek, getWeeksAsync } from '../../api/getWeeks';

class WeekStore {
    catWeekList: Array<CatWeek> = [];
    isLoading: boolean = false;
    currentPage: number = 1;
    error: string = "";

    constructor() {
        makeAutoObservable(this);
    }

    nextPage = () => {
        this.currentPage = this.currentPage + 1;
        this.getWeeksForUser();
    }

    prevPage = () => {
        if (this.currentPage > 1) {
            this.currentPage = this.currentPage - 1;
            this.getWeeksForUser();
        }
    }

    getWeeksForUser = () => {
        if (!this.isLoading) {
            this.isLoading = true;
        }
       runInAction(() => {
            getWeeksAsync(this.currentPage).then(res => {
                const data = res.data;
                this.catWeekList = Array.isArray(data) ? data : [];

                if (this.isLoading) {
                    this.isLoading = false;
                }
            }).catch(err => {
                this.error = err
                if (this.isLoading) {
                    this.isLoading = false;
                }
            })
        })
    }
}
export default WeekStore;